export default __webpack_public_path__ + "static/media/logo-sm.a4f839ad.png";